var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("view-page", {
    attrs: {
      title: _vm.pageTitle,
      "permission-name": "asset_reservation_object",
      "edit-button": false,
      "delete-button": false,
      loading: _vm.loading
    },
    scopedSlots: _vm._u([
      {
        key: "leftSide",
        fn: function() {
          return _vm._l(_vm.fields, function(field) {
            return _vm.fields.length > 0
              ? _c("view-page-data-field", {
                  key: field.label,
                  attrs: {
                    icon: field.icon,
                    label: field.label,
                    data: field.data
                  }
                })
              : _vm._e()
          })
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-348ae237", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-348ae237","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Data/AssetDetails.vue
// module id = null
// module chunks = 